import { useState } from 'react'
import { exportElement } from '../../utils/exportElement'

// Botões "Baixar JPEG" / "Baixar PDF" de um elemento da tela.
// getTarget devolve o elemento a exportar; onError recebe a mensagem de falha.
function ExportButtons({ getTarget, fileName, title, onError, size = 'md' }) {

    const [ _isExporting, _setExporting ] = useState(false)

    const _handleExport = async (format) => {

        const node = getTarget()

        if (!node || _isExporting) return

        _setExporting(true)

        try {
            await exportElement(node, { format, fileName, title })
        } catch (error) {
            onError?.(error.message || 'Não foi possível gerar o arquivo.')
        } finally {
            _setExporting(false)
        }
    }

    const sizeClass = size === 'sm' ? 'h-8 px-3 text-[0.75rem]' : 'h-10'

    return (

        <div className="flex gap-2" data-export-ignore>

            {['jpeg', 'pdf'].map(format => (
                <button
                    key={format}
                    type="button"
                    className={`flex btn ${sizeClass} items-center bg-white !text-azul-profundo-m border border-azul-profundo-m hover:bg-azul-ceu-c disabled:opacity-60 disabled:cursor-wait`}
                    onClick={() => _handleExport(format)}
                    disabled={_isExporting}
                >
                    {_isExporting ? 'Gerando...' : `Baixar ${format.toUpperCase()}`}
                </button>
            ))}

        </div>
    )
}

export default ExportButtons
